// Components
import RenderDateWithFromTime from '@/common-utils/components/renders/date/RenderDateWithFromTime';
import Entity from '@/common-utils/components/renders/entity/Entity';
import DetailsButton from '@/common-utils/components/renders/detailsButton/DetailsButton';
import ColumnSelection from '@/common-utils/components/renders/dataTable/column/ColumnSelection';
import RenderPlanLabel from '../../renders/RenderPlanLabel';
// Common
import generateColumnDefByField from '@/common-utils/functions/generateColumnDefByField';
import plansFields from '../../../fields/plansFields';
import generateNestedFieldAccessor from '@/common-utils/functions/generateNestedFieldAccessor';
import getObjectAttributeFromStringKey from '@/common-utils/functions/getObjectAttributeFromStringKey';
import RouteUrls from '@/app/root/enums/RouteUrls';
import Permissions from '@/app/permissions/Permissions';

export const columnsPlansId = 'plans';

export const columnsPlans = (headerPackage) => {

    return ([
        // ColumnSelection
        headerPackage.selectionMode && ColumnSelection(columnsPlansId, headerPackage.singleSelection),
        generateColumnDefByField({
            field: plansFields.DETAILS,
            headerPackage: headerPackage,
            customCellFn: ({ row }) => (
                <DetailsButton
                    pathParams={{ planId: row.original.uuid }}
                    baseUrl={RouteUrls.PLAN_DETAILS.url}
                    requiredPermissions={[Permissions.SUBSCRIPTION_PLAN_READ.name]}
                />
            ),
            show: !headerPackage.selectionMode
        }),
        generateColumnDefByField({
            field: plansFields.PARENT_SUBSCRIPTION_PLAN.LABEL,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <Entity entity={getObjectAttributeFromStringKey(cell.row.original, generateNestedFieldAccessor(plansFields.PARENT_SUBSCRIPTION_PLAN.LABEL))} />
            )
        }),
        generateColumnDefByField({
            field: plansFields.LABEL,
            headerPackage: headerPackage,
            isLongText: true,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderPlanLabel plan={cell.row.original} />
            )
        }),
        generateColumnDefByField({
            field: plansFields.PRODUCT_CODE,
            headerPackage: headerPackage,
            isLongText: true
        }),
        generateColumnDefByField({
            field: plansFields.CREATED_AT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(plansFields.CREATED_AT.key)} />
            )
        }),
        generateColumnDefByField({
            field: plansFields.UPDATED_AT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(plansFields.UPDATED_AT.key)} />
            )
        })
    ]).filter(col => !!col);
};